<template>
  <Popover :has-close-icon="false">
    <template #trigger="{ togglePopover }">
      <button
        :class="{ 'bg-primary text-neutral': isActive }"
        class="navigation-item flex items-center gap-x-1"
        @click="
          trackMenu();
          togglePopover();
        ">
        <slot />
        <UiIcon
          size="sm"
          :class="
            isActive
              ? 'bg-primary text-neutral hover:text-neutral'
              : 'text-neutral-emphasis hover:text-neutral-primary'
          "
          name="chevron-down" />
      </button>
    </template>
    <template #content="{ closePopover }">
      <PriorityPlusList>
        <li v-for="item in navigationItem.children" :key="item.id" class="flex">
          <CvdNavigationRouterLink
            active-class="text-primary border-l-primary pointer-events-none cursor-default"
            :to="{
              name: 'cvdPage',
              params: { slug: [navigationItem.slug, item.slug] },
            }"
            variant="dropdown"
            @click="
              handleNavigationLinkClick(item);
              closePopover();
            ">
            {{ t(item.labelKey) }}
          </CvdNavigationRouterLink>
        </li>
      </PriorityPlusList>
    </template>
  </Popover>
</template>

<script setup lang="ts">
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import CvdNavigationRouterLink from "@/components/Cvd/CvdNavigation/CvdNavigationRouterLink.vue";
import PriorityPlusList from "@/components/Cvd/PriorityPlus/PriorityPlusList.vue";
import Popover from "@/components/shared/Popover/Popover.vue";
import { useTracking } from "@/composition/shared/useTracking.ts";
import type { TopLevelNavigationItem } from "@/types/Cvd.ts";

const route = useRoute();
const { t } = useI18n();
const { navigationItem } = defineProps<{
  navigationItem: TopLevelNavigationItem;
}>();

const isActive = computed(() => {
  return navigationItem.children?.some((child) =>
    route.path.includes(child.slug),
  );
});

const { trackEvent } = useTracking();
function trackMenu() {
  trackEvent(
    "categoryNavigation_click_textButton_navlink",
    navigationItem.slug,
  );
}

function handleNavigationLinkClick(item: TopLevelNavigationItem) {
  trackEvent("categoryNavigation_click_textButton_navlink", item.slug);
}
</script>
